import { RfidServiceInterface} from "interfaces/rfid-service.ts";
import { BaseBusinessService } from "services/mms/external-api/business/base-business-service"
import { BackendSchema } from "layouts/charging-rules/interface/Rules.ts"
import { ExportFilterRfid } from "types/rfid"
import { buildQueryFromExportFilterRfid } from "layouts/rfid/utils/functions.ts"

export class BusinessRfidService
    extends BaseBusinessService
    implements RfidServiceInterface
{
    useGetListRfidCards = (filter_obj: ExportFilterRfid | null) => {
        const endpoint = buildQueryFromExportFilterRfid(filter_obj)
        return this.get({ endpoint })
    }

    useGetListRfidActiveCards = () => {
        return this.get({endpoint: ''})
    }

    useGetListRfidUnactiveCards = () => {
        return this.get({endpoint: ''})
    }

    useGetDriverRfidsCards = (driver_id: string): FetchApiProps => {
        return this.get({ endpoint: `/driver/` + driver_id })
    }

    useUpdateRfidCard = (rfid_id: string): FetchApiProps => {
        return this.put({ endpoint: '/' + rfid_id })
    }

    useUpdateStatusRfidCard = (rfid_id: string): FetchApiProps => {
        return this.put({endpoint: '/'+ rfid_id})
    }

    useGetRfidCardRule = (rfid_id: string): FetchApiProps => {
        return this.get({ endpoint: '/' + rfid_id })
    }

    useUpdateRfidCardRule = (rfid_id: string, rfid_rule: BackendSchema): FetchApiProps => {
        return this.post({ endpoint: '/' + rfid_id, options: { body: rfid_rule } })
    }
}
